export const PROMOCODES = {
  ENERGYWELL: 'energywell',
  ENERGYWELL_CART_SIGNUPS: 'energywell-cart-signups',
  AMBIT: 'ambit',
  AMBIT_ENERGY: 'ambit-energy',
  NO_COMMS_ENERGYWELL: 'no-comms-welcome-purchased-energywell-0323',
};
export const SPONSORED_SOLAR = 'sponsored_solar';

export const renderReferralModule = (promocode: string): boolean => {
  const noReferralPromoCodes = [
    PROMOCODES.ENERGYWELL,
    PROMOCODES.ENERGYWELL_CART_SIGNUPS,
    PROMOCODES.AMBIT,
    PROMOCODES.AMBIT_ENERGY,
    PROMOCODES.NO_COMMS_ENERGYWELL,
  ];
  return !noReferralPromoCodes.includes(promocode);
};
